import { isMobile } from '../../util';

const CartBanner = ({
    accountId, sourceId, retailerId, placementId
}) => {
    return (
        <div className='surfside-menu-banner surfside-cart-banner'>
            <surf-banner
                className='surf-ad-placement'
                account-id={accountId}
                channel-id="bf9bc"
                site-id={sourceId}
                placement-id={placementId}
                location-id={retailerId}
                keywords='cart'
                zone='cart'
                type='inline'
                adtypes='0,1'
                width={isMobile() ? "4" : "8"}
                height={1}
            ></surf-banner>
        </div>
    );
};

export default CartBanner;
